import App from '@/App.vue'
import router from '@/router'
import { createApp } from 'vue'

import '@/assets/styles/index.css'
import '@/assets/styles/input.css'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import {
  faBars,
  faBuilding,
  faBuildingCircleCheck,
  faChartLine,
  faCircleQuestion,
  faFileExport,
  faFileLines,
  faGauge,
  faGears,
  faLock,
  faMicrochip,
  faShieldHalved,
  faUserGear,
  faUsers,
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faBars,
  faShieldHalved,
  faGauge,
  faChartLine,
  faBuilding,
  faUsers,
  faLock,
  faMicrochip,
  faUserGear,
  faGears,
  faBuildingCircleCheck,
  faFileExport,
  faFileLines,
  faCircleQuestion
)

const app = createApp(App)

app.component('font-awesome-icon', FontAwesomeIcon)

app.use(router)

app.mount('#app')
